export default __webpack_public_path__ + "static/media/cluser-marker.1153d902.svg";